import { TreeNodeTypes } from './tree-node-types';
import { TreeNode as PrimeTreeNode } from 'primeng/api';
import { PAsset, PerspectiveTreeNode, PGroup } from 'app/perspectives/interfaces/interfaces';

export interface PGroupValue {
  id: string;
  parentId: string;
  type: string;
  value: string;
  assets?: PerspectiveTreeNode[];
  perspectiveId?: string;
  isDefault?: boolean;
}

export interface IResetCounts {
  dsNodes: IResetCountsInfo[];
}

export interface IResetCountsInfo {
  groupName: string;
  nodeName: string;
  deviceName?: string;
}

export interface Data {
  type?: string;
  // pGroup?: PGroup|PAsset;
  pGroupValue?: PGroupValue;
  [key: string]: number | string | boolean | { type: string; value: string } | Array<{[key: string]: string}> | string[] | {[key:string]: DatasetValue|string}|PGroup|PAsset|PGroupValue;
}

export interface DatasetValue {
  columnNames: string[];
  numberOfColumn: number;
  values: Array<{[key: string]: string}>;
}

export interface NodeMetadata {
  label: string;
  children?: NodeMetadata[];
  data?: Data | null; // Can be null or key/value pair
  nodeType: TreeNodeTypes; // Remember to switch to string only
  expandable?: boolean;
  expanded?: boolean;
  status?: boolean;
  perspectiveId?: string;
  // displayVal?: { type: string, val: unknown };
}

export class TreeNode implements NodeMetadata, PrimeTreeNode {
  public label: string;
  public children: TreeNode[];
  public data?: Data | null; // Can be null or key/value pair
  public nodeType: TreeNodeTypes; // Remember to switch to string only
  public parent: TreeNode;
  public status: boolean = false;
  public fqn: string;
  public level = 0;
  public expandable: boolean;
  // public displayVal: { type: string, val: unknown };
  public expanded: boolean;
  public hidden = false;
  public type: string;
  public perspectiveId?: string;

  constructor(meta: NodeMetadata, parent?: TreeNode) {
    this.label = meta.label;
    this.data = meta.data;
    this.parent = parent ? parent : undefined;
    this.nodeType = meta.nodeType;
    this.status = meta.status;
    this.expandable = meta.expandable !== undefined && meta.expandable !== null ? meta.expandable : true;
    this.expanded = meta.expanded !== undefined && meta.expanded !== null ? meta.expanded : true;
    this.children = [];
    this.perspectiveId = meta.perspectiveId;
    // this.displayVal = meta.displayVal ? meta.displayVal : undefined;
    this.fqn = this.BuildFQN(parent);
    // this.expanded = true;

    if (parent) {
      this.parent = parent;
    }

    if (meta.data && meta.data.displayVal) {
      this.type = 'metric';
    }

    // if (parent) {
    //     this.level = parent.level++;
    // } else {
    //     this.level = 0;
    // }

    if (meta.children) {
      meta.children.forEach(c => this.AddChild(new TreeNode(c, this)));
    }
  }

  public get hasParent(): boolean {
    return this.parent ? true : false;
  }


  public get hasChild(): boolean {
    return !!this.children && this.children.length > 0 && this.expandable ? true : false;
  }

  public get findRoot(): TreeNode {
    return this.rootLookup(this);
  }

  public expandUpward(): void {
    if (this.parent) {
      this.parent.expanded = true;
      this.parent.expandUpward();
    }
  }

  public expandDownward(firstLevelOnly: boolean = false): void {
    if (this.children && this.children.length > 0) {
      this.expanded = true;

      if (!firstLevelOnly) {
        this.children.forEach(child => {
          child.expandDownward(true);
        });
      }
    }
  }

  public removeNode(node: TreeNode) {
    this.children = this.children.filter(pn => pn.label !== node.label);
  }

  public AddChild(node: TreeNode): void {
    const nodeExist: number = this.children.findIndex(x => x.label === node.label);
    if (nodeExist === -1) {
      // node.level = this.level++;
      node.parent = this;
      this.children.push(node);
    }
  }

  public AppendToGroup(path: string, node?: TreeNode) {
    if (!path || path === '') {
      if (node) { this.AddChild(node); }
      return;
    }

    const pathSegs = path.split('/');
    const currentSeg = pathSegs.shift();
    let subGroup = this.children.find(x => x.label === currentSeg && x.nodeType === TreeNodeTypes.GROUP);

    if (!subGroup) {
      subGroup = new TreeNode({
        label: currentSeg,
        nodeType: TreeNodeTypes.GROUP
      });

      subGroup.AppendToGroup(pathSegs.join('/'), node);
      subGroup.expanded = true;

      this.AddChild(subGroup);
    } else {
      subGroup.AppendToGroup(pathSegs.join('/'), node);
    }
  }

  private rootLookup(node: TreeNode): TreeNode {
    if (node.parent) {
      return this.rootLookup(node.parent);
    } else {
      return node;
    }
  }

  public setNodeType(nodeType: TreeNodeTypes) {
    this.nodeType = nodeType;
  }

  public addData(data: Data) {
    this.data = data;
    if (this.data.displayVal) {
      this.type = 'metric';
    }
  }

  public CheckMatch(searchParam: string, value: unknown): TreeNode {
    if (this.data && this.data[searchParam] === value) {
      return this;
    }
  }

  /**
   * hasChildWithLabelName
   *
   * @param labelName
   * @returns boolean
   *
   * Returns true if the current node has a child with the label name
   */
  public hasChildWithLabelName(labelName: string): boolean {
    return !!this.getChildWithLabelName(labelName);
  }

  /**
   * getChildWithLabelName
   *
   * @param labelName
   * @returns TreeNode
   *
   * Returns the node child with the given label name
   */
  public getChildWithLabelName(labelName: string) {
    return this.children.find(el => el.label === labelName);
  }

  protected BuildFQN(parent?: TreeNode): string {
    let fqn: string;

    if (parent && parent.fqn) {
      fqn = `${parent.fqn}/${this.label}`;
    } else {
      fqn = this.label;
    }

    return fqn;
  }
}
